export default {
    monthly: 'Monthly',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    exportText: 'Export Text',
    selectAll: 'Select All'
}
